import fr from 'facet-rest';
import Autocomplete from 'Components/UI/Autocomplete';

export const metaOverrideSet = fr.metaOverride()
  .nameOverride(['limit', 'offset', 'id', 'timestamp', 'sessionId', 'platform', 'sort'], { hidden: true })
  .typeOverride('picklist', {
    _component: () => Autocomplete,
  });
